import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { Typography } from '@material-ui/core';
import { DashboardPanelEmptyState } from "../DashboardPanel/DashboardPanelEmptyState";

export interface DashboardFavouritesListEmptyProps {}

export const DashboardFavouritesListEmpty = (props: DashboardFavouritesListEmptyProps) => {
  const intl = useIntl();
  
  return (
    <DashboardPanelEmptyState iconname='favouriteLarge'
                              linkText={intl.formatMessage({id: 'DashboardFavouritesEmptyButton'})}
                              linkUrl={intl.formatMessage({id: 'LinkDashboardEmptyFavourites'})}>
      <Typography component='h3' variant='h4'>
        <FormattedMessage id='DashboardFavouritesEmptyText' />
      </Typography>
    </DashboardPanelEmptyState>
  );
};
